
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class Logout extends Vue {
  @Prop({ type: String, default: "" }) public loginTitle;
  public imgSrc = "img/login/close.png"
  public mounted() {
    if (this.loginTitle == "") {
      this.imgSrc = "homeIcons/retreat.png"
    }
  }
  public getImgUrl() {
    return require(`@/assets/${this.imgSrc}`);
  }
  public onClickLeft() {
    if (this.loginTitle !== "") return this.$router.push({name: 'my'});
    this.$router.back();
  }
  public onClickRight() {
    if (this.loginTitle == "手机号登录") return this.$router.push({name: 'notPassWord'});
    this.$router.push({name: 'login'})
  }
}
